<template>
    <div class="modal fade" id="popUpCliente" data-backdrop="static"  role="dialog" aria-modal="true">
        <div class="modal-dialog" :class="{'modal-lg': !$root.isMobile, 'modal-fullscreen': $root.isMobile}" :style="modalStyle">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background-color: #3D519C;">
                    <h4 style="color:#fff" class="modal-title">
                        <i class="fal"
                            :class="cliente?.TIPOLOGIA_CLIENTE == 1 ? 'fa fa-user' : cliente?.TIPOLOGIA_CLIENTE == 2 ? 'fa fa-building' : cliente?.TIPOLOGIA_CLIENTE == 3 ? 'fa fa-industry-alt' : ''"></i>
                        Cliente: "{{ cliente?.FK_ID_PERSONA_FISICA != 0 && cliente?.ID_CLIENTE > 0 ?
                            cliente?.personaFisica?.NOME + ' ' + cliente?.personaFisica?.COGNOME :
                            cliente?.personaGiuridica?.DENOMINAZIONE || 'N/A' }}"
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    <ul class="nav nav-tabs" id="tabs" role="tablist" style="margin-top:5px; justify-content: center">
                        <li class="nav-item">
                            <a class="nav-link isprint-tab active tab-cliente" data-toggle="tab" id="linkAnagrafiche"
                                data-tab="statsAnagrafiche" href="#statsAnagrafiche" role="tab"
                                aria-controls="statsAnagrafiche" aria-selected="false">
                                <i class="fal fa-address-book"></i> Anagrafica
                            </a>
                        </li>
                        <li   v-if="$root.isGod == 1" class="nav-item">
                            <a class="nav-link isprint-tab tab-cliente" data-toggle="tab" id="linkListe"
                                data-tab="statsListe" href="#statsListe" role="tab" aria-controls="statsListe"
                                aria-selected="true">
                                <i class="fal fa-link"></i> Liste
                            </a>
                        </li>
                        <li  v-if="$root.isGod == 1"  class="nav-item">
                            <a class="nav-link isprint-tab tab-cliente" data-toggle="tab" id="linkContratti"
                                data-tab="statsContratti" href="#statsContratti" role="tab"
                                aria-controls="statsContratti" aria-selected="true">
                                <i class="fal fa-file-contract"></i> Contratti
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link isprint-tab tab-cliente" data-toggle="tab" id="linkScadenze"
                                data-tab="statsScadenze" href="#statsScadenze" role="tab" aria-controls="statsScadenze"
                                aria-selected="true">
                                <i class="fal fa-calendar-exclamation"></i> Scadenze
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content card-tab" style="margin-top:20px">
                        <!-- Anagrafica -->
                        <div class="tab-pane active" id="statsAnagrafiche" style="height:100%" role="tabpanel">
                            <div class="form-group col-md-12">
                                <div class="row mt-4 mb-4">
                                    <div class="btn-group" role="group" style="margin:0 auto;" aria-label="Basic example">
                                        <div class="btn-group" role="group" :class="{'w-100 d-flex flex-column': $root.isMobile, 'd-flex justify-content-center': !$root.isMobile}" aria-label="Basic example">
                                            <button :style="buttonStyle" :disabled="cliente.ID_CLIENTE > 0 || amministratoreSelezionato.ID_PERSONA_FISICA > 0"
                                                type="button" class="btn btn-lg mb-2" :class="{ 'btn-primary': cliente.TIPOLOGIA_CLIENTE == 1, 'btn-light': cliente.TIPOLOGIA_CLIENTE != 1 }"
                                                @click="selezionaTipologiaCliente(1)">
                                                <i class="fal fa-user"></i> Persona Fisica
                                            </button>
                                            <button :style="buttonStyle"  :disabled="cliente.ID_CLIENTE > 0 || amministratoreSelezionato.ID_PERSONA_FISICA > 0"
                                                type="button" class="btn btn-lg mb-2" :class="{ 'btn-primary': cliente.TIPOLOGIA_CLIENTE == 2, 'btn-light': cliente.TIPOLOGIA_CLIENTE != 2 }"
                                                @click="selezionaTipologiaCliente(2)">
                                                <i class="fal fa-building"></i> Condominio
                                            </button>
                                            <button :style="buttonStyle"  :disabled="cliente.ID_CLIENTE > 0 || amministratoreSelezionato.ID_PERSONA_FISICA > 0"
                                                type="button" class="btn btn-lg mb-2" :class="{ 'btn-primary': cliente.TIPOLOGIA_CLIENTE == 3, 'btn-light': cliente.TIPOLOGIA_CLIENTE != 3 }"
                                                @click="selezionaTipologiaCliente(3)">
                                                <i class="fal fa-industry-alt"></i> Società
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="margin-top: 10px;">
    <!-- Consumo A. Luce -->
                                    <div :class="cliente.TIPOLOGIA_CLIENTE == 1 ? 'col-md-4' : cliente.TIPOLOGIA_CLIENTE == undefined ? 'col-md-6' : 'col-md-3'">
                                        <div class="form-group">
                                            <label>Consumo A.Luce</label>
                                            <input type="text" class="form-control form-control-sm" @paste="rimuoviPunti('CONSUMO_ANNUALE_LUCE')" placeholder="Inserisci Consumo Luce" v-model="cliente.CONSUMO_ANNUALE_LUCE">
                                        </div>
                                    </div>

                                    <!-- Consumo A. Gas -->
                                    <div :class="cliente.TIPOLOGIA_CLIENTE == 1 ? 'col-md-4' : cliente.TIPOLOGIA_CLIENTE == undefined ? 'col-md-6' : 'col-md-3'">
                                        <div class="form-group">
                                            <label>Consumo A. Gas</label>
                                            <input type="text" class="form-control form-control-sm"  @paste="rimuoviPunti('CONSUMO_ANNUALE_LUCE')" placeholder="Inserisci Consumo Gas" v-model="cliente.CONSUMO_ANNUALE_GAS">
                                        </div>
                                    </div>

                                    <!-- Agente -->
                                    <div v-show="cliente.TIPOLOGIA_CLIENTE"  :class="{'col-md-4': cliente.TIPOLOGIA_CLIENTE == 1, 'col-md-3': cliente.TIPOLOGIA_CLIENTE != 1}">
                                        <div class="form-group" style="margin-left: 20px;">
                                            <label>Agente</label>
                                            <Select2
                                                v-model="cliente.FK_ID_AGENTE" 
                                                :w="cliente.TIPOLOGIA_CLIENTE == 1 ? 260 : 150" 
                                                :api="'es/agente/select2?a=1'" 
                                                :apiselected="'es/agente/s2'">
                                            </Select2>
                                        </div>
                                    </div>

                                    <!-- Amministratore -->
                                    <div v-show="cliente.TIPOLOGIA_CLIENTE != 1 && cliente.TIPOLOGIA_CLIENTE != undefined" class="col-md-3">
                                        <div class="form-group">
                                            <label>Amministratore</label>
                                            <div class="input-group">
                                                <select class="form-control form-control-sm" v-model="cliente.FK_ID_AMMINISTRATORE">
                                                    <option v-for="amministratore in arrayAmministratori" :key="amministratore.ID_AMMINISTRATORE" :value="amministratore.ID_AMMINISTRATORE">
                                                        {{ amministratore.COGNOME }} {{ amministratore.NOME }}
                                                    </option>
                                                </select>
                                                <div class="input-group-append">
                                                    <div class="btn-group dropright">
                                                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                                                    <div class="dropdown-menu">
                                                        <a class="dropdown-item" style="font-size: 18px;" v-on:click=" creaAmministratore()" >Crea Amministratore <i class="fa fa-plus" aria-hidden="true"></i></a>
                                                        <a class="dropdown-item"  style="font-size: 18px;" v-on:click="modificaAmministratore(amministratore)">Modifica Amministratore <i class="fa fa-pen" aria-hidden="true"></i></a>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="row" v-show="cliente.TIPOLOGIA_CLIENTE > 0">
                                    <!-- Persona Fisica -->
                                    <div class="form-group col-md-12" v-show="cliente.TIPOLOGIA_CLIENTE == 1">
                                        <PersonaFisica v-model="cliente.personaFisica"></PersonaFisica>
                                    </div>
                                    <!-- Persona Giuridica -->
                                    <div class="col-12" v-show="cliente.TIPOLOGIA_CLIENTE > 1">
                                        <PersonaGiuridica v-model="cliente.personaGiuridica"></PersonaGiuridica>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Liste -->
                        <div v-if="$root.isGod == 1"  class="tab-pane" id="statsListe" style="height:100%" role="tabpanel" v-show="cliente.ID_CLIENTE > 0">
                            <div class="row">
                                <div class="col-md-4" v-for="tipologiaLista in arrayTipologiaListe" :key="tipologiaLista.ID_LISTA" style="margin-top: 20px;"
                                    @click="tipologiaLista.SELEZIONATO == 1 ? eliminaLista(tipologiaLista) : inserisciLista(tipologiaLista)">
                                    <div class="card lift-panel" :class="tipologiaLista.SELEZIONATO == 1 ? 'bg-primary pers' : 'bg-white-pers'" style="border-radius: 6px;">
                                        <div class="card-body d-flex h-100" style="padding: 0.5rem 0.5rem; font-weight: bold;">
                                            <div class="justify-content-center align-self-center" style="font-size: 18px;">
                                                <i class="fal fa-link fa-fw"></i>{{ tipologiaLista.DESCRIZIONE }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Contratti -->
                        <div v-if="$root.isGod == 1"  class="tab-pane" id="statsContratti" style="height:100%" role="tabpanel" v-show="cliente.ID_CLIENTE > 0">
                            <div class="row">
                                <div class="col-12">
                                    <button class="btn btn-success float-right btn-sm" @click="modificaContratto({ ID_CONTRATTO: 0, FK_ID_CLIENTE: cliente.ID_CLIENTE })"
                                        style="transform: translate(5px,-5px)"><i class="fal fa-plus"></i> Nuovo Contratto
                                    </button>
                                    <div class="isprint-grid-modal-container" style="margin-top: 20px;">
                                        <table class="isprint-grid-modal shadow"  style="table-layout: fixed; width: 100%;">
                                            <thead class="isprint-grid-modal-thead">
                                                <tr style="background:#559CB8;color:#fff">
                                                    <th style="width:20%;">Codice Contratto</th>
                                                    <th style="width:10%">Tipologia Contratto</th>
                                                    <th style="width:20%">Tipologia Calcolo</th>
                                                    <th style="width:10%">Fornitore</th>
                                                    <th style="width:20%">Scadenza</th>
                                                    <th style="width:10%">Azioni</th>
                                                </tr>
                                            </thead>
                                            <tbody class="isprint-grid-modal-tbody" style="font-size:14px;">
                                                <tr v-for="contratto in paginatedListContratti.arr" :key="contratto.ID_CONTRATTO">
                                                    <td style="width:20%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                        {{ contratto.NUMERO_CONTRATTO }}
                                                    </td>
                                                    <td style="width:10%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                        <span class="badge" v-if="contratto.FK_ID_TIPO == 1">
                                                            <i class="fas fa-lightbulb text-warning"></i>{{ $root.isMobile==true ? '' : ' LUCE' }}
                                                        </span>
                                                        <span class="badge" v-else-if="contratto.FK_ID_TIPO == 2">
                                                            <i class="fas fa-gas-pump text-danger"></i>{{ $root.isMobile==true ? '' : ' GAS' }}
                                                        </span>
                                                    </td>
                                                    <td style="width:20%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                        <span class="badge" v-if="contratto.FK_ID_CALCOLO_MODALITA_IMPORTO == 1">
                                                            <i class="fas fa-thumbtack"></i>{{ $root.isMobile==true ? '' : ' FISSO' }}
                                                        </span>
                                                        <span class="badge" v-else-if="contratto.FK_ID_CALCOLO_MODALITA_IMPORTO == 2">
                                                            <i class="fas fa-chart-bar"></i>{{ $root.isMobile==true ? '' : ' VARIABILE' }}
                                                        </span>
                                                    </td>
                                                    <td style="width:10%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                        <img v-if="contratto.URL_IMMAGINE != ''" :src="getPathImg(contratto.URL_IMMAGINE)" class="img-responsive" style="max-height:30px; max-width:50px;">
                                                        <span v-else class="badge">
                                                            <strong><i class="fal fa-warehouse"></i> {{ contratto.FK_ID_FORNITORE != 0 ? contratto.DENOMINAZIONE_FORNITORE : 'Nessuno'  }}</strong>
                                                        </span>
                                                    </td>
                                                    <td style="width:20%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                        <span class="badge">
                                                            <i class="fal fa-calendar-exclamation"></i>
                                                            {{ filters.formatDate(contratto.DATA_SCADENZA) }}
                                                        </span>
                                                    </td>
                                                    <td style="width:10%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                        <div class="btn-group">
                                                            <button class="btn btn-warning btn-sm mr-2" @click="modificaContratto(contratto)">
                                                                <i class="fal fa-pencil"></i>
                                                            </button>
                                                            <button class="btn btn-danger btn-sm" @click="deleteContratto(contratto)">
                                                                <i class="fal fa-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <Pagine v-model="searchContratti.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListContratti.count" :numpagine="searchContratti.PAGINATION.LENGTH"></Pagine>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Scadenze -->
                        <div class="tab-pane" id="statsScadenze" style="height:100%" role="tabpanel" v-show="cliente.ID_CLIENTE > 0">
                            <div class="row">
                                <div class="col-12">
                                    <button class="btn btn-success btn-sm" 
                                        @click="aggiungiScadenza()" 
                                        :class="{'float-right': !$root.isMobile, 'd-block mx-auto mb-2': $root.isMobile}" 
                                        style="margin-top: 10px;">
                                        <i class="fal fa-plus"></i> Nuova Scadenza
                                    </button>

                                    <!-- Modalità desktop (tabella) -->
                                    <div v-if="!$root.isMobile" class="isprint-grid-modal-container" style="margin-top: 20px;">
                                        <table class="isprint-grid-modal shadow" style="table-layout: fixed; width: 100%;">
                                            <thead class="isprint-grid-modal-thead">
                                                <tr style="background:#559CB8;color:#fff">
                                                    <th style="width:20%">Data Scadenza</th>
                                                    <th style="width:60%">Note</th>
                                                    <th style="width:10%">Lavorato</th>
                                                    <th style="width:10%">Azioni</th>
                                                </tr>
                                            </thead>
                                            <tbody class="isprint-grid-modal-tbody" style="font-size:14px;">
                                                <tr v-for="scadenza in paginatedListScadenze.arr" :key="scadenza.ID_SCADENZA">
                                                    <td style="width:20%;">
                                                        <span class="badge"><i class="fal fa-calendar-exclamation"></i>
                                                            {{ filters.formatDate(scadenza.DATA_SCADENZA) }}
                                                        </span>
                                                    </td>
                                                    <td style="width:60%; ">
                                                        <i class="fal fa-sticky-note"></i> {{ scadenza.NOTE }}
                                                    </td>
                                                    <td style="width:10%;">
                                                        <ISwitch v-model="scadenza.FLG_LAVORATO" @toggle="updateLavorazione(scadenza)"
                                                            :size="'sm'" style="margin-top:6px"></ISwitch>
                                                    </td>
                                                    <td style="width:10%;">
                                                        <div class="btn-group">
                                                            <button class="btn btn-warning btn-sm mr-2" @click="modificaScadenza(scadenza)">
                                                                <i class="fal fa-pencil"></i>
                                                            </button>
                                                            <button v-if="scadenza.FLG_LAVORATO == 1" class="btn btn-danger btn-sm"
                                                                @click="deleteScadenza(scadenza)">
                                                                <i class="fal fa-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <Pagine v-model="searchScadenza.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListScadenze.count"
                                            :numpagine="searchScadenza.PAGINATION.LENGTH"></Pagine>
                                    </div>

                                        <!-- Modalità mobile (card) -->
                                        <div v-else>
                                            <div class="card mb-3" v-for="scadenza in paginatedListScadenze.arr" :key="scadenza.ID_SCADENZA">
                                                <div class="card-body">
                                                    <h5 class="card-title">
                                                        <i class="fal fa-calendar-exclamation"></i>
                                                        Scadenza: {{ filters.formatDate(scadenza.DATA_SCADENZA) }}
                                                    </h5>
                                                    <p class="card-text">
                                                        <strong>Note:</strong> {{ scadenza.NOTE }}<br />
                                                        <strong>Lavorato:</strong> 
                                                        <ISwitch v-model="scadenza.FLG_LAVORATO" @toggle="updateLavorazione(scadenza)"
                                                            :size="'sm'" style="margin-top:6px"></ISwitch>
                                                    </p>
                                                    <div class="btn-group float-right" role="group">
                                                        <button class="btn btn-warning btn-sm mr-2" @click="modificaScadenza(scadenza)">
                                                            <i class="fal fa-pencil"></i>
                                                        </button>
                                                        <button v-if="scadenza.FLG_LAVORATO == 1" class="btn btn-danger btn-sm"
                                                            @click="deleteScadenza(scadenza)">
                                                            <i class="fal fa-trash-alt"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <Pagine v-model="searchScadenza.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListScadenze.count"
                                                :numpagine="searchScadenza.PAGINATION.LENGTH"></Pagine>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="position-relative d-inline-block">
                        <!-- Messaggio a vignetta -->
                        <div 
                            v-show="amministratoreSalvato && cliente.TIPOLOGIA_CLIENTE != 1" 
                            class="tooltip-bubble"
                        >
                            Clicca su <strong>Salva</strong> per salvare l'associazione tra cliente e amministratore
                            <div class="tooltip-arrow"></div>
                        </div>

                        <!-- Pulsante Salva -->
                        <button 
                            :disabled="cliente.TIPOLOGIA_CLIENTE === undefined && cliente.personaGiuridica.DENOMINAZIONE == ''" 
                            class="btn btn-success float-right" 
                            @click="salvaCliente()">
                            <i class="fa fa-check"></i> Salva
                        </button>
                    </div>
                </div>


            </div>
        </div>
    </div>



    <!-- PopUp Scadenzario -->
    <div class="modal fade" id="popUpScadenzario2" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog" :class="{'modal-lg': !$root.isMobile, 'modal-fullscreen': $root.isMobile}">
            <div class="modal-content">
                <div class="modal-header modal-header-primary">
                    <h5 style="color:#fff;" class="modal-title"><i class="far fa-calendar-plus fa-fw"></i> Aggiungere Cliente allo Scadenzario?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label>Data Scadenza:</label>
                                <DatePicker placeholder="data scadenza" autocomplete="off" :dim="'sm'" type="text" style="width:100%" v-model="scadenzaSelezionata.DATA_SCADENZA"></DatePicker>
                            </div>
                            <div class="form-group col-md-8">
                                <label>Descrizione:</label>
                                <textarea class="form-control form-control-sm" rows="5" placeholder="Inserisci le tue note qui..." v-model="scadenzaSelezionata.NOTE"></textarea>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Annulla</button>
                    <button type="button" class="btn btn-success" @click="salvaScadenza()">Salva</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="popUpAmministratore" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog"  :class="{'modal-lg': !$root.isMobile, 'modal-fullscreen': $root.isMobile}">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background:#3D519C">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-user-crown fa-fw"></i> Amministratore</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group col-md-12">
                        <PersonaFisica v-model="amministratoreSelezionato.personaFisica"></PersonaFisica>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaAmministratore()"><i class="fa fa-check"></i>
                        Salva</button>
                </div>
            </div>
        </div>
    </div>


    <PopUpContratto ref="modalContratto" @contratto-salvato="getCliente(cliente.ID_CLIENTE)"></PopUpContratto>
</template>

<script>

import PersonaFisica from '../components/common/PersonaFisica.vue';
import PersonaGiuridica from '../components/common/PersonaGiuridica.vue';
import Pagine from '@/components/utils/Pagine.vue';
import PopUpContratto from '../components/PopUpContratto.vue';
import DatePicker from '../components/utils/DatePicker.vue';
import ISwitch from '../components/utils/ISwitch.vue';
import Select2 from '../components/utils/Select2.vue';
import { reactive } from 'vue';
import { utils } from '../assets/js/utils';


export default {
    components: {
        PersonaFisica,
        PersonaGiuridica,
        Pagine,
        PopUpContratto,
        DatePicker,
        ISwitch,
        Select2,

    },
    emits: ['salva-cliente'],
    props: {
        clienteSelezionato: {
            type: Object,
            required: true
        },
        arrayTipologiaListe: {
            type: Array,
            required: false,
        }
    },
    data() {
        return {
            cliente: reactive({ ...this.clienteSelezionato }),
            amministratoreSelezionato: {personaFisica:{}},
            amministratoreSalvato : false,
            pulsanteSelezionato: 0,
            scadenzaSelezionata: {},
            arrayAmministratori:new Array(),
            filters: global.filters,
            searchScadenza: {
                PAGINATION: {
                    LENGTH: 0,
                    PAGE_NUMBER: 1,
                    PAGE_SIZE: 8 
                }
            },
            searchContratti: {
                PAGINATION: {
                    LENGTH: 0,
                    PAGE_NUMBER: 1,
                    PAGE_SIZE: 8 
                }
            },

            tipologiaListeLocal: reactive([...this.arrayTipologiaListe])
            
        };
    },
    methods: {
        isButtonDisabled() {
            return this.cliente.TIPOLOGIA_CLIENTE === undefined && this.cliente.personaGiuridica === '';
        },
        openPopUp(clienteData = {}) {
            this.cliente = { ...clienteData };
            if(this.cliente.ID_CLIENTE > 0){
                this.pulsanteSelezionato = 1
                this.amministratoreSalvato = false
            }else{
                this.cliente.personaGiuridica.DENOMINAZIONE = '';
                this.cliente.personaFisica.NOME = '';
                this.cliente.personaFisica.COGNOME = '';
                this.pulsanteSelezionato = 0;
                this.amministratoreSalvato = false
            }
            $('#linkAnagrafiche').tab('show');
            utils.openModal('popUpCliente');
            this.getAmministratori();
        },
        closePopUp() {
            //utils.closeModal('popUpCliente');
        },
        getAmministratore(idAmministratore) {
            this.amministratoreSelezionato = { personaFisica: {} };
            global.utils.get('es/amministratore', { ID_AMMINISTRATORE: idAmministratore }, (response) => {
                this.amministratoreSelezionato = utils.clone(response.data);
            });
        },
        selezionaTipologiaCliente(tipologia) {
            this.cliente = { ...this.cliente, TIPOLOGIA_CLIENTE: tipologia };
            this.pulsanteSelezionato = 1;
        },
        inserisciLista(tipologiaLista) {
            global.utils.post('es/lista', { FK_ID_LISTA_CLIENTE: tipologiaLista.ID_LISTA, FK_ID_CLIENTE: this.cliente.ID_CLIENTE }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio);
                    tipologiaLista.SELEZIONATO = 1;
                }
            });
        },
        eliminaLista(tipologiaLista) {
            global.utils.delete('es/lista', { FK_ID_LISTA_CLIENTE: tipologiaLista.ID_LISTA, FK_ID_CLIENTE: this.cliente.ID_CLIENTE }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio);
                    tipologiaLista.SELEZIONATO = 0;
                }
            });
        },
        /* openPopUpAmministratore() {
            if (this.cliente.FK_ID_AMMINISTRATORE == 0) {
                utils.openModal('popUpAmministratore');
            } else {
                this.getAmministratore(this.cliente.FK_ID_AMMINISTRATORE);
                utils.openModal('popUpAmministratore');
            }
        }, */
        modificaContratto(contratto) {
            if (contratto.ID_CONTRATTO > 0) {
                this.$refs.modalContratto.openSchedaContratto({ ID_CONTRATTO: contratto.ID_CONTRATTO, FK_ID_CLIENTE: this.cliente.ID_CLIENTE}, false);
            } else {
                this.$refs.modalContratto.openSchedaContratto({ ID_CONTRATTO: 0, FK_ID_CLIENTE: this.cliente.ID_CLIENTE, FK_ID_FORNITORE : 0 }, false);
            }
        },
        deleteContratto(contratto) {
            utils.alert.confirm('Sei sicuro di voler eliminare il contratto selezionato?', () => {
                global.utils.delete('/es/contratto', { ID_CONTRATTO: contratto.ID_CONTRATTO }, (response) => {
                    if (response.esito === 0) {
                        utils.alert.success(response.messaggio);
                        this.getCliente(this.cliente.ID_CLIENTE);
                    }
                });
            },this.$root);
        },
        aggiungiScadenza() {
            this.scadenzaSelezionata = { ID_SCADENZA: 0, FK_ID_CLIENTE: this.cliente.ID_CLIENTE };
            utils.openModal('popUpScadenzario2');
        },
        salvaCliente() {
            if (this.cliente.TIPOLOGIA_CLIENTE != undefined && ((this.cliente.personaFisica.NOME && this.cliente.personaFisica.COGNOME) || this.cliente.personaGiuridica.DENOMINAZIONE)) {
                    this.$emit('salva-cliente', this.cliente);
            }else{
                utils.alert.warning('Verifica i dati: Scegliere la tipologia e inserire NOME e COGNOME o DENOMINAZIONE.');
            }
        },

        updateLavorazione(scadenza) {
            setTimeout(() => {
                utils.ajax('es/scadenza/update', scadenza, (response) => {
                    if (response.esito === 0) {
                        utils.alert.success(response.messaggio);
                        $('#popUpScadenzario2').modal('hide');
                    }
                });
            }, 250);
        },
        salvaScadenza() {
            if (this.scadenzaSelezionata.ID_SCADENZA > 0) {
                global.utils.put('/es/scadenza', this.scadenzaSelezionata, (response) => {
                    if (response.esito === 0) {
                        this.scadenzaSelezionata.DATA_SCADENZA = this.filters.formatDateReverse(this.scadenzaSelezionata.DATA_SCADENZA);
                        this.getCliente(this.cliente.ID_CLIENTE);
                        utils.closeModal('popUpScadenzario2');
                        utils.alert.success(response.messaggio);
                    }
                });
            } else {
                global.utils.post('/es/scadenza', this.scadenzaSelezionata, (response) => {
                    if (response.esito === 0) {
                        this.scadenzaSelezionata.DATA_SCADENZA = this.filters.formatDateReverse(this.scadenzaSelezionata.DATA_SCADENZA);
                        this.getCliente(this.cliente.ID_CLIENTE);
                        utils.closeModal('popUpScadenzario2');
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        getCliente(idcliente) {
            global.utils.get('/es/cliente', { ID_CLIENTE: idcliente }, (response) => {
                this.cliente = utils.clone(response.data);
                this.tipologiaListeLocal = this.arrayTipologiaListe
                if(this.cliente.contratti){
                    this.searchContratti.PAGINATION.LENGTH = this.cliente.contratti.length;
                }
                if(this.cliente.scadenze){
                    this.searchScadenza.PAGINATION.LENGTH = this.cliente.scadenze.length;
                }
                
                for (let i = 0; i < this.tipologiaListeLocal.length; i++) {
                    this.tipologiaListeLocal[i].SELEZIONATO = 0;
                    for (let j = 0; j < this.cliente.liste.length; j++) {
                        if (this.tipologiaListeLocal[i].ID_LISTA == this.cliente.liste[j].FK_ID_LISTA_CLIENTE) {
                            this.tipologiaListeLocal[i].SELEZIONATO = 1;
                        }
                    }
                }
            });
        },
        modificaData(giorniDaAggiungere) {
            let data = new Date(this.filters.formatDateReverse(this.scadenzaSelezionata.DATA_SCADENZA));
            data.setDate(data.getDate() - giorniDaAggiungere);
            this.scadenzaSelezionata.DATA_SCADENZA = this.filters.formatDate(data.toISOString().split('T')[0]);
        },
        getPathImg(url) {
            return utils.BASE_API + '../../UPLOAD' + url;

        },
        modificaScadenza(scadenza) {
        this.scadenzaSelezionata = utils.clone(scadenza);

        this.scadenzaSelezionata.DATA_SCADENZA = this.filters.formatDate(scadenza.DATA_SCADENZA);
        utils.openModal('popUpScadenzario2');
        },
        deleteScadenza: function (scadenza) {
            utils.alert.confirm("Sei sicuro di voler eliminare la Scadenza selezionata?", () => {
                global.utils.delete('/es/scadenza', { ID_SCADENZA: scadenza.ID_SCADENZA }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getCliente(this.cliente.ID_CLIENTE)
                    }

                });
            }, this.$root);
        },
        creaAmministratore: function () {
            this.amministratoreSelezionato = { ID_PERSONA_FISICA: 0 , personaFisica: {COGNOME:'' , NOME:''}}
            var modal = utils.openModal('popUpAmministratore');
        },
        modificaAmministratore: function(){
            this.amministratoreSelezionato = { personaFisica: {} };
            this.getAmministratore(this.cliente.FK_ID_AMMINISTRATORE);
            var modal = utils.openModal('popUpAmministratore')
        },
        salvaAmministratore : function(){
            if(this.amministratoreSelezionato.ID_PERSONA_FISICA == 0){
                console.dir(this.amministratoreSelezionato.personaFisica)
                if(this.amministratoreSelezionato.personaFisica.NOME && this.amministratoreSelezionato.personaFisica.COGNOME){
                    global.utils.post('/es/amministratore', this.amministratoreSelezionato, (response) => {
                        if (response.esito == 0) {
                            this.amministratoreSelezionato.ID_AMMINISTRATORE = response.id_inserito;
                            this.cliente.FK_ID_AMMINISTRATORE = response.id_inserito;
                            this.getAmministratori();
                            this.amministratoreSalvato = true
                            var modal = utils.closeModal('popUpAmministratore');
                            utils.alert.success(response.messaggio);
                        }
                    });
                }else{
                    utils.alert.warning("È necessario specificare il NOME e il COGNOME dell'Amministratore")
                }
            }else{
                if(this.amministratoreSelezionato.personaFisica.NOME != '' && this.amministratoreSelezionato.personaFisica.COGNOME != ''){
                    global.utils.put('/es/amministratore', this.amministratoreSelezionato, (response) => {
                        if (response.esito == 0) {
                            this.getAmministratori();
                            this.amministratoreSalvato = true
                            var modal = utils.closeModal('popUpAmministratore');
                            utils.alert.success(response.messaggio);
                        }
                    });
                }else{
                    utils.alert.warning("È necessario specificare il NOME e il COGNOME dell'Amministratore")
                }
            }
        },
        getAmministratori: function () {
            this.arrayAmministratori = new Array();
            utils.wait(()=>{
                global.utils.get('/es/amministratori', {}, (response) => {
                    this.arrayAmministratori = response.data;
                },false);                
            })
        },
        rimuoviPunti : function(prop){
            utils.wait(()=>{
                this.cliente[prop] = this.cliente[prop].toString().replace(",","") ;
                this.cliente[prop] = this.cliente[prop].toString().replace(".","") ;
            });
            
        }

    },
    watch: {
        pageSize(newSize) {
            this.searchScadenza.PAGINATION.PAGE_SIZE = newSize;
        }
    },
    mounted() {
        this.searchScadenza.PAGINATION.PAGE_SIZE = this.pageSize;
        this.getAmministratori();
    },
    computed: {
        modalStyle() {
            return this.$root.isMobile ? { width: 'auto' } : { 'min-width': '1000px' };
        },
        buttonStyle() {
            return this.$root.isMobile ? { width: '100%', height: '60px' } : { width: '185px', height: '60px' };
        },
        paginatedListScadenze() {
            return utils.inGrid(this.cliente.scadenze!=undefined ? this.cliente.scadenze : [] , this.searchScadenza);
        },
        paginatedListContratti() {
            return utils.inGrid(this.cliente.contratti!=undefined ? this.cliente.contratti : []  , this.searchContratti);
        },
        pageSize() {
            return this.$root.isMobile ? 1 : 8;
        }
    },
};
</script>

<style scoped>
.modal-content {
    background-color: #fff;
}

.bg-white-pers {
    background-color: whitesmoke;
    color: #4e73df;
}
.tooltip-bubble {
    position: absolute;
    top: -75px; /* Posiziona il messaggio sopra e a sinistra del pulsante */
    right: -250px; /* Spostato verso sinistra rispetto al pulsante */
    background-color: rgba(248, 193, 70, 0.9); /* Sfondo giallo trasparente */
    color: #fff; /* Testo bianco */
    padding: 10px;
    border-top-right-radius: 15px; /* Angoli arrotondati */
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Ombra */
    font-size: 0.875rem; /* Testo leggermente più piccolo */
    z-index: 10; /* Sopra altri elementi */
    opacity: 1; /* Leggera trasparenza dell'intero messaggio */
    text-align:center;
    width: 259px;
}



@media (max-width: 768px) {
    .modal-fullscreen {
        width: 100%;
        max-width: 100%;
        height: 100%;
        margin: 0;
    }
}
</style>
